var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ui-data-export',{attrs:{"rows":_vm.rows,"columns":_vm.exportColumns,"disabled":_vm.disabled,"filename":("aktivitäten-log-" + (_vm.now().format('YYYY-MM-DD-HHmm')))}})}
var staticRenderFns = []

export { render, staticRenderFns }